enum NOTIFICATIONS {
    SW_UPDATED = 'service_worker_updated',
    SW_INITIALIZED = 'service_worker_initialized',
}

// eslint-disable-next-line import/prefer-default-export
export { NOTIFICATIONS };
